import * as C from "./styles.js";

export default function CarouselLoad() {
    return (
        <C.Container>
            <C.Content>
                <header>
                    <div></div>
                    <div></div>
                    <div></div>
                </header>
                <main>
                    <div className="title"></div>
                    <div className="subtitle"></div>
                    <div className="subtitle"></div>
                    <div className="subtitle"></div>
                </main>
                <footer>
                    <div></div>
                </footer>
            </C.Content>
        </C.Container>
    )
}